import { DRIVERLOCATION } from "../Constants/driverLocation";

export const driverLocationInfo = (params) => {
    return {
        type: DRIVERLOCATION.driver_Location,
        payload: params
    }
}
